"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var animation_frame_1 = require("./animation-frame");
// Default easing function
// jQuery easing 'swing'
// tslint:disable-next-line:no-magic-numbers
var easeOutQuad = function (_, t, b, c, d) { return -c * (t /= d) * (t - 2) + b; };
function removeHash() {
    var url = window.location.toString().split("#")[0];
    window.history.replaceState({}, document.title, url);
}
function updateHistory(id) {
    if (id) {
        window.location.hash = id;
    }
    else {
        removeHash();
    }
}
exports.updateHistory = updateHistory;
function getScroll() {
    // like jQuery -> $('html, body').scrollTop
    return document.documentElement.scrollTop || document.body.scrollTop;
}
function scroll(position) {
    document.documentElement.scrollTop = document.body.scrollTop = position;
}
function getOffsetTop(element) {
    return element.getBoundingClientRect().top;
}
var scrollToken = -1;
function animateScroll(id, animate) {
    var _this = this;
    var element = id ? document.getElementById(id) : document.body;
    if (!element) {
        console.warn("Cannot find element: #" + id);
        return undefined;
    }
    var _a = animate || {}, 
    // default animate object
    _b = _a.offset, 
    // default animate object
    offset = _b === void 0 ? 0 : _b, 
    // tslint:disable-next-line:no-magic-numbers
    _c = _a.duration, 
    // tslint:disable-next-line:no-magic-numbers
    duration = _c === void 0 ? 400 : _c, _d = _a.easing, easing = _d === void 0 ? easeOutQuad : _d;
    var startTime = Date.now();
    scrollToken = startTime;
    var s0 = getScroll();
    var change = getOffsetTop(element) + offset;
    var animateFn = function () { return __awaiter(_this, void 0, void 0, function () {
        var dt, position;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dt = Date.now() - startTime;
                    position = easing(undefined, dt, s0, change, duration);
                    scroll(position);
                    if (!(dt < duration)) return [3 /*break*/, 2];
                    return [4 /*yield*/, animation_frame_1.animationFrame()];
                case 1:
                    _a.sent();
                    if (scrollToken !== startTime)
                        return [2 /*return*/];
                    animateFn();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    animateFn();
    return id;
}
exports.animateScroll = animateScroll;
//# sourceMappingURL=utils.js.map


//////////////////
// WEBPACK FOOTER
// ./~/preact-scrollchor/dist/utils.js
// module id = 291
// module chunks = 2